<template>
  <div class="sm:col-span-6">
    <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-28">
      <div class="relative flex items-start " @click="setDestination(DELIVERY_TYPE.DIGITAL)">
        <div class="ml-3 flex h-6 items-center">
          <input type="radio" name="certificateType" :checked="destination === DELIVERY_TYPE.DIGITAL"
                 id="digital" value=""
                 class="h-4 w-4 mr-4 flex border-gray-400 text-blue-700 focus:ring-blue-700"/>
        </div>
        <div class="min-w-0 flex-1 text-sm text-gray-700 font-medium leading-6">
          <label for="digital">Digital</label>
          <p class="text-gray-400 font-light">(Versand sofort per E-Mail)</p>
        </div>
      </div>

      <div class="relative flex items-start" @click="setDestination(DELIVERY_TYPE.CURRENT_ADDRESS)">
        <div class="ml-3 flex h-6 items-center">
          <input type="radio" name="certificateType" :checked="destination !== DELIVERY_TYPE.DIGITAL"

                 id="printed" value=""
                 class="h-4 w-4 mr-4 flex border-gray-400 text-blue-700 focus:ring-blue-700"/>
        </div>
        <div class="min-w-0 flex-1 text-sm text-gray-700 font-medium leading-6">
          <label for="printed">Gedruckte Bürgschaftsurkunde</label>
          <p class="text-gray-400 font-light">(Versand in wenigen Tagen per Post)</p>
        </div>
      </div>
    </div>

    <div class="sm:col-span-6 my-8 font-medium text-sm text-gray-700">
      Um die Umwelt zu schonen und die Bürgschaftsurkunde direkt per E-Mail zu erhalten, empfehlen wir die digitale
      Bürgschaft.
    </div>


    <span v-if="showDestinationPossibilities" class="relative mt-6 z-0 shadow-sm rounded-md">
      <p class="font-medium text-green-400">Wohin soll Ihre gedruckte Bürgschaftsurkunde geschickt werden?</p>

      <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-12 mt-4">
        <div class="relative flex items-start " @click="setDestination(DELIVERY_TYPE.CURRENT_ADDRESS)">
          <div class="ml-3 flex h-6 items-center">
            <input type="radio" name="destinationAddress" :checked="destination === DELIVERY_TYPE.CURRENT_ADDRESS"
                   id="aktuelleAdresse" value=""
                   class="h-4 w-4 mr-4 flex border-gray-400 text-blue-700 focus:ring-blue-700"/>
          </div>
          <div class="min-w-0 flex-1 text-sm text-gray-700 font-medium leading-6">
            <label for="printed">Aktuelle Adresse</label>
            <p class="text-gray-400 font-light">{{ tenant.formattedTenantAddress }}</p>
          </div>
        </div>

        <div class="relative flex items-start" @click="setDestination(DELIVERY_TYPE.NEW_PROPERTY)">
          <div class="ml-3 flex h-6 items-center">
            <input type="radio" name="destinationAddress" :checked="destination === DELIVERY_TYPE.NEW_PROPERTY"
                   id="neueAdresse" value=""
                   class="h-4 w-4 mr-4 flex border-gray-400 text-blue-700 focus:ring-blue-700"/>
          </div>
          <div class="min-w-0 flex-1 text-sm text-gray-700 font-medium leading-6">
            <label for="printed">Neue Adresse</label>
            <p class="text-gray-400 font-light">{{ tenant.formattedPropertyAddress }}</p>
          </div>
        </div>

        <div class="relative flex items-start" @click="setDestination(DELIVERY_TYPE.LANDLORD)">
          <div class="ml-3 flex h-6 items-center">
            <input type="radio" name="destinationAddress" :checked="destination === DELIVERY_TYPE.LANDLORD"
                   id="neueAdresse" value=""
                   class="h-4 w-4 mr-4 flex border-gray-400 text-blue-700 focus:ring-blue-700"/>
          </div>
          <div class="min-w-0 flex-1 text-sm text-gray-700 font-medium leading-6">
            <label for="printed">Vermieter Adresse</label>
            <p class="text-white">-</p>
          </div>
        </div>
      </div>

    </span>
    <p v-if="errors['next_destAddress']" class="mt-2 text-sm text-red-600 error-message">{{ errors[next_destAddress] }}</p>
    <input type="hidden"
           id="next_destAddress"
           name="next_destAddress"
           :value="destination"
           class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-400 rounded-md"
           aria-invalid="false"/>


    <!-- this should only appear (and be made required) if landlord is chosen on the previous step -->
    <fieldset v-if="tenant.formValues.next_destAddress === DELIVERY_TYPE.LANDLORD"
              class="mt-6 grid grid-cols-1 sm:grid-cols-6 sm:col-span-6 gap-y-6 gap-x-4"
              data-destination-target="landlordAddress">
      <div class="sm:col-span-6 text-green-400 font-medium">
        Wie lautet die Adresse Ihres Vermieters?
      </div>
      <Address address-type="landlord" />
    </fieldset>


  </div>
</template>

<script setup>
import {computed, watch} from "vue";
import {useTenantStore} from "../stores/tenant";
import { DELIVERY_TYPE } from "../utils/constants";
import Address from "./Address.vue";

const tenant = useTenantStore();

const destination = computed(() => tenant.formValues.next_destAddress);
const errors = computed(() => tenant.errors);
const showDestinationPossibilities = computed(() => tenant.showDestinationPossiblities);

const setDestination = (type) => {
  tenant.setFormValue('next_destAddress', type);
  if (type === DELIVERY_TYPE.NEW_PROPERTY) {
    tenant.resetLandlordAddress();
  }
};

watch(destination, async (destination) => {
  await tenant.validateField('next_destAddress', destination);
  await tenant.validateField('next_landlordEmail', tenant.formValues.next_landlordEmail);
});

</script>

